// extracted by mini-css-extract-plugin
module.exports = {"content":"Control_content__1usHw","horizontalButtonsWrapper":"Control_horizontalButtonsWrapper__1yyWN"};